import type { IconSvgObject } from './types';

const MailsIcon: IconSvgObject = [
  ["path", { d: "M9 3H20C21.1046 3 22 3.89543 22 5V13C22 14.1046 21.1046 15 20 15H9C7.89543 15 7 14.1046 7 13V5C7 3.89543 7.89543 3 9 3Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 9C2.89543 9 2 9.89543 2 11V19C2 20.1046 2.89543 21 4 21H15C16.1046 21 17 20.1046 17 19V18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M22 6L15.4412 9.49804C14.8529 9.81176 14.1471 9.81176 13.5588 9.49804L7 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default MailsIcon;
